import { useSelector } from 'react-redux';
import _ from 'lodash';
import InputForm from '../InputForm';
import { RootState } from '../../../../../../../state/store';
import formCashFlowStatementTemplate from './formCashFlowStatementTemplate.json';
import { getRowTemplate, getFormDataFromState, getForm } from '../../common/FormUtil';
import { FormGroup, FormType, FormGroupType, FormGroupI } from '../../../../../../../types/inputform.d';

export const generateFormCashFlowStatement = (
  group: FormGroupType,
  cashFlowStatementCells: any,
  dbJson: any,
  loanDetails: any
) => {
  const formCells = _.cloneDeep(cashFlowStatementCells);
  let allRows: any[] = [];
  let formDataCells: any;

  if (!_.isEmpty(formCells)) {
    formDataCells = getFormDataFromState(formCells, group);
  } else if (_.isEmpty(formCells)) {
    const formCashFlowStatement = _.cloneDeep(formCashFlowStatementTemplate) as any;

    // Total Rows //
    allRows = getRowTemplate('label', formCashFlowStatement);

    formDataCells = getForm(
      formCells,
      FormType[FormType.FORMCASHFLOWSTATEMENT].toLowerCase(),
      group,
      allRows,
      dbJson,
      loanDetails
    );
  }

  // if (group === FormGroup.PROJECTION) {
  //   Object.entries(formJson).map(([, cell]) => cell?.expr && cellUpdate(copyCells, cell, cell?.expr));
  // }
  return formDataCells;
};

export const FormCashFlowStatement = ({ group }: FormGroupI) => {
  const cells = useSelector(
    (state: RootState) => state?.inputscreen?.cells![FormType[FormType.FORMCASHFLOWSTATEMENT].toLowerCase()]
  );

  if (!group || !cells) return <></>;

  const cellData: any = {};

  const actualsCells = Object.fromEntries(
    Object.entries(cells).filter(([, value]: any) => value?.group === FormGroup[FormGroup.ACTUALS].toLowerCase())
  );
  _.merge(cellData, actualsCells);

  if (group === FormGroup.PROJECTION) {
    const projectionCells = Object.fromEntries(
      Object.entries(cells).filter(
        ([, value]: any) => value?.group === FormGroup[FormGroup.PROJECTION].toLowerCase()
      )
    );
    _.merge(cellData, projectionCells);
  }

  return <InputForm cells={cellData} />;
};
